import { styled } from "@mui/material/styles";

import { CurrentUserMenuProps } from "./index";

const PREFIX = "CurrentUserMenu";

export const classes = {
  button: `${PREFIX}-button`,
  buttonTitle: `${PREFIX}-buttonTitle`,
  accountIcon: `${PREFIX}-accountIcon`,
  usernameSkeleton: `${PREFIX}-usernameSkeleton`,
  accountTitle: `${PREFIX}-accountTitle`,
  popper: `${PREFIX}-popper`,
};

const StyledCurrentUserMenu = styled("div", {
  shouldForwardProp: (prop) => prop !== "cookieConsentManagement",
})<CurrentUserMenuProps>(({ theme }) => ({
  [`& .${classes.button}`]: {
    maxHeight: "10vh",
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.primary,
    alignSelf: "stretch",
    "& + &": {
      marginLeft: theme.spacing(2),
    },
  },

  [`& .${classes.buttonTitle}`]: {
    textTransform: "none",
  },

  [`& .${classes.accountIcon}`]: {
    marginRight: ".25rem",
  },

  [`& .${classes.usernameSkeleton}`]: {},

  [`& .${classes.accountTitle}`]: {
    marginRight: ".5rem",
    whiteSpace: "pre",
  },

  [`& .${classes.popper}`]: {
    zIndex: 1,
  },

  [`& .CurrentUserPopup-button`]: {
    textAlign: "left",
  },
}));

export default StyledCurrentUserMenu;
